export class UtilCalc {

  /** APIから取得したデータを百分率に変換してreturn
   * @param {string} gridColumn 百分率に変換するグリッドのカラム名
   * @param {any} response APIからのレスポンス
   */
  divide100(gridColumn: string, response: any): number {
    const resArray = [];
    resArray.push(response);
    if (resArray[0].length > 0) {
      resArray[0].forEach(function(value, index, array) {
        value[gridColumn] = value[gridColumn] / 100;
      });
      return response = resArray[0];
    }
  }

  /** 絶対値を取得 */
  absValue(number: number): number {
    return number < 0 ? -number : number;
  }

  /** 最大桁数から最大値を算出する(4桁　→　9999)
   * @param {number} numOfDigits 最大桁数
   * @returns {number} 最大値
   */
  public numOfDigitsToMaxLength(numOfDigits: number): number {
    let maxLength = null;
    if (!numOfDigits) {
      return maxLength;
    }
    maxLength = 0;
    for (let i = 0; i < numOfDigits; i++) {
      maxLength += (10 ** i) * 9;
    }
    return maxLength;
  }

  /** 最大値から最大桁数を算出する(9999　→　4桁)
   * @param {number} maxLength 最大値
   * @returns {number} 最大桁数
   */
  public maxLengthToNumOfDigits(maxLength: number): number {
    let numOfDigits = null;
    if (!maxLength) {
      return numOfDigits;
    }
    numOfDigits = String(maxLength) ? String(maxLength).length : null;
    return numOfDigits;
  }

  /** 数値を０埋めして文字列を返す */
  public paddingZero(num: number, paddingSize: number): string {
    let zeroString = '';
    for (let i = 0; i < paddingSize; i++) {
      zeroString += '0';
    }
    return (zeroString + num).slice(paddingSize * -1);
  }

  public static arrayChunk([...array], size: number): any[] {
    return array.reduce((acc, value, index) => index % size ? acc : [...acc, array.slice(index, index + size)], []);
  }
}
